import { render, staticRenderFns } from "./TeamSettingView.vue?vue&type=template&id=4d84df6f&"
import script from "./TeamSettingView.vue?vue&type=script&lang=js&"
export * from "./TeamSettingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports